<template>
  <div class="data_upload page">

  <div class="w-full mx-auto bg-white text-center">
 
 
 <div
            class="w-full mx-auto p-6 pb-10 bg-white rounded-xl z-10"
          >

            <section
              class="w-full text-center mt-2"
              v-if="isSaving || isSuccess"
            >

              <div class="progress-circle__container">
                <span class="progress-circle__percent font-bold text-lg"
                  >{{ completedPercentage }}%</span
                >

                <svg
                  class="progress-circle"
                  viewBox="0 0 106 106"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <g
                    id="Page-1"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <g
                      id="ProgressBar"
                      transform="translate(-17.000000, -17.000000)"
                    >
                      <circle
                        id="Oval"
                        stroke="#949494"
                        stroke-width="7"
                        fill-rule="nonzero"
                        cx="70"
                        cy="70"
                        r="50"
                      ></circle>
                      <path
                        class="progress-circle__path"
                        d="M70,120 C97.6142375,120 120,97.6142375 120,70 C120,42.3857625 97.6142375,20 70,20 C42.3857625,20 20,42.3857625 20,70 C20,97.6142375 42.3857625,120 70,120 Z"
                        id="Oval-Copy"
                        stroke="#1F254A"
                        stroke-width="5"
                        :stroke-dasharray="circle"
                        fill-rule="nonzero"
                        transform="translate(70.000000, 70.000000) rotate(-125.000000) translate(-70.000000, -70.000000) "
                      ></path>
                    </g>
                  </g>
                </svg>
              </div>
              <p>Uploading file</p>
            </section>

            <section v-if="isComplete" class="w-full text-center mt-2">
              <h3 class="font-bold text-xl text-action-blue">Your file has been uploaded. </h3>
              <p class="text-action-blue">The imported data will be checked by our team and then added to your account. You will be notified within 72 hours when this is complete.</p>
              <button
                @click="refreshUpload()"
                type="button"
                class="publish-button hover:bg-blue-300 mt-4"
              >
                Upload another document
              </button>
            </section>

            <form
              class=" space-y-2 px-4"
              v-on:submit.prevent="submitUpload"
              v-if="isInitial"
            >
              <div class="grid grid-cols-1 space-y-3">
                <label class="text-sm font-bold text-gray-600 tracking-wide"
                  >Attach Document</label
                >
                <p v-if="hasFile" class="font-bold text-red-400">
                Selected file {{ file.name }}
              </p>
                <div class="flex items-center justify-center w-full"  v-on:click="showUpload()">
                  <label
                    class="
                      flex flex-col
                      rounded-lg
                      border-4 border-dashed
                      w-full
                      h-48
                      p-10
                      group
                      text-center
                      cursor-pointer
                    "
                  >
                    <div
                      class="
                        h-full
                        w-full
                        text-center
                        flex flex-col
                        items-center
                        justify-center
                        items-center
                      "
                    >
                      <div class="flex flex-auto max-h-48 w-2/5 mx-auto -mt-10">
                        <img
                          class="has-mask h-32 object-center p-2 mt-6"
                          src="/static/images/empty/document.png"
                          alt="Add document resource"
                        />
                      </div>
                      <p class="pointer-none text-gray-500">
                        <span class="text-sm">Click to select</span> a file from
                        your computer
                      </p>
                    </div>
                    <input
                      type="file"
                      class="hidden"
                      v-on:change="handleFileUpload()"
                      ref="file"
                    />
                  </label>
                </div>
              </div>

              <div class="grid grid-cols-1 space-y-2 pt-4">
                <label class="text-sm font-bold text-gray-600 text-left tracking-wide">
                Notification Contact</label>
                <p class="text-left text-xs opacity-50">The registered school PE lead will be notified upon completion of the data upload. 
                  For an additional notification please enter an email adress below. </p>
              <input
                v-model="notificationContact"
                  class="
                    p-3
                    mb-5
                    bg-white
                    border border-gray-200
                    rounded
                    h-36
                    focus:bg-white focus:outline-none
                  "
                type="email"
                placeholder="Enter contact email"
              />
            </div>

              <div class="grid grid-cols-1 space-y-2 pt-4">
                <label class="text-sm font-bold text-gray-600  text-left tracking-wide"
                  >Additional Notes</label
                >
                <input
                  class="
                    p-3
                    mb-5
                    bg-white
                    border border-gray-200
                    rounded
                    h-36
                    focus:bg-white focus:outline-none
                  "
                  type=""
                  v-model="notes"
                  placeholder="Additional notes..."
                />
              </div>



              <p class="text-sm text-gray-400">
                <span>File type: csv</span>
              </p>
              <p v-if="hasFile" class="font-bold text-red-400">
                Upload file {{ file.name }}
              </p>
              <div>
                <button
                @click="submitUpload()"
                  type="submit"
                  class="
                    publish-button
                    hover:opacity-50
                    my-5
                    w-full
                    flex
                    justify-center
                    p-4
                    tracking-wide
                    focus:outline-none
                    focus:shadow-outline
                    shadow-lg
                    cursor-pointer
                    transition
                    ease-in
                    duration-300
                    disabled:opacity-50 disabled:cursor-not-allowed
                  "
                  :disabled="isDisabled"
                >
                  Upload
                </button>
              </div>
            </form>
          </div>

  </div>

  </div>
</template>

<script>
import { SchoolService } from "@/services/school.service";
import { fileImportMixin } from "@/mixins/file-ImportMixin.js";

import { mapGetters } from "vuex";

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

export default {
  name: "data_upload",
  mixins: [fileImportMixin],
  data() {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: "photos",
      notes: '',
      notificationContact: '',
      file: {},
    };
  },
  computed: {
    ...mapGetters({ currentUser: "currentUser" }),
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    hasFile() {
      return this.file.name != undefined && this.file.name.length > 3;
    },
    circle() {
      return ((this.completedPercentage / 100) * 100 * Math.PI) + ',9999';
    },
    isDisabled() {
      if (this.hasFile && (this.notificationContact.length > 3)) {
        return false
      } else {
        return true
      }
      

    }
  },
  methods: {
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    submitUpload() {

      let formData = new FormData();
      formData.append("file", this.file);
      const result = this.importDocument(formData);

      result.then((response) => {
        this.postUploadFileData();
      });
    },
    postUploadFileData() {
 
        let payload = { 
           "title": this.currentUser.name,
           "filename": this.remoteName,
           "notes": this.notes,
           "notify_email": this.notificationContact,
        }


      SchoolService.create("datauploadnotice", payload)
          .catch(err => {
            console.log("Contact error " + err);
          });
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    showUpload() {
      if ((this.currentStatus = STATUS_INITIAL)) {
        this.reset();
      }

      var input = document.createElement('input');
      input.type = 'file';
      input.onchange = e => { 
        this.file = e.target.files[0]; 
      }
      input.click();
 
    }
  },
  mounted() {
    this.reset();
  }
};
</script>

<style scoped>


.dropbox {
  outline: 0px dashed #f56a6a; /* the dash box */
  outline-offset: 0px;
  background: transparent;
  color: dimgray;
  padding: 0px 0px;
  min-height: 382px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
</style>